module.exports = __webpack_public_path__ + "img/荣誉证书12_环境管理体系认证证书.61abd226.png";